export default "__VITE_ASSET__689a6709__"